import React, { useEffect } from 'react'
import UppyUpload from "./UppyUpload"
import "./upload.css"
const UppyModal = ({ show, onSuccess, onClose }) => {
    useEffect(() => {
        if (show) {
            UppyUpload({}, {}, onSuccess, onClose);
        }
    }, [show])

    return (
        <div>
            {/* <button id="" onClick={() => UppyUpload({}, {}, onSuccess)}>trigger uppy</button> */}
            <div id="drag-drop-area---airbook"></div>
        </div>
    )
}

export default UppyModal